import { render, staticRenderFns } from "./StandartModuleConnectionForm.vue?vue&type=template&id=0a07af00"
import script from "./StandartModuleConnectionForm.vue?vue&type=script&lang=js"
export * from "./StandartModuleConnectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports